import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { actionFor } from "../lib/notif-action";

export const DASHBOARD_NOTIFICATIONS_KEY = ["dashboard", "notifications"] as const;

// ponytail: the BE's `severity` param takes one value and `ack` isn't
// filterable, so the filter is client-side either way; 200 is comfortably
// past any plausible P1/P2 backlog. Revisit with per-severity requests only
// if it ever isn't.
const LIST_LIMIT = 200;

/**
 * GET /v1/notifications → the dashboard's "Action required" list: unacked
 * P1/P2 alerts that carry a next step (see `actionFor`), newest 5.
 */
export function useNotifications(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: DASHBOARD_NOTIFICATIONS_KEY,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/notifications", {
        params: { query: { limit: LIST_LIMIT } },
      });
      if (error) throw error;
      return data;
    },
    enabled: options?.enabled ?? true,
    select: (data) =>
      data.items
        .filter(
          (n) => (n.severity === "P1" || n.severity === "P2") && !n.ack && actionFor(n) !== null,
        )
        .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
        .slice(0, 5),
    refetchInterval: 60_000,
  });
}
